import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/backoffice.css';

export default function AdminLayout({ children, onLogout }) {
    return <div className="backoffice">
        <header className="bo-header"><Link to="/" className="wordmark" aria-label="Boca de Sapo, volver al sitio">BOCA DE SAPO</Link><span className="bo-area">ESPACIO EDITORIAL</span><nav aria-label="Navegación de administración"><Link to="/">Ver sitio <span aria-hidden="true">↗</span></Link>{onLogout && <button type="button" onClick={onLogout}>Cerrar sesión</button>}</nav></header>
        {onLogout && <nav className="bo-sections" aria-label="Secciones del backoffice"><NavLink to="/adminmain" end>Noticias</NavLink><NavLink to="/adminmain/numeros">Números y artículos</NavLink></nav>}
        <main id="contenido" className="bo-main">{children}</main>
        <footer className="bo-footer"><span>BOCA DE SAPO · ARTE, LITERATURA Y PENSAMIENTO</span><span>Administración editorial</span></footer>
    </div>;
}
